import { Form, FormikProvider, useFormik } from 'formik';
import axios from 'axios';
import {
  Alert,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  Stack,
  TextField,
  Autocomplete,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import propTypes from 'prop-types';
import { useState } from 'react';

const token = JSON.parse(localStorage.getItem('user'));

TreePotEditForm.propTypes = {
  treepot: propTypes.object,
  types: propTypes.array,
  closeModal: propTypes.func,
  reloadData: propTypes.func,
};

export default function TreePotEditForm(props) {
  const { treepot, closeModal, reloadData, handleSnackCreateSuccess, types } = props;
  const [isUploadingImage, setIsUploadingImage] = useState(false);

  const formik = useFormik({
    initialValues: treepot
      ? { ...treepot }
      : {
          url: '',
          cost: '',
          type: '',
        },
    onSubmit: (values, formikHelpers) => {
      (treepot != null
        ? axios.put(`${process.env.REACT_APP_SERVICE_BASE_URL}/tree-pot/${treepot._id}`, values, {
            headers: {
              token: token.token,
            },
          })
        : axios.post(`${process.env.REACT_APP_SERVICE_BASE_URL}/tree-pot`, values, {
            headers: {
              token: token.token,
            },
          })
      )
        .then(() => {
          closeModal();
          reloadData();
          handleSnackCreateSuccess();
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          formikHelpers.setSubmitting(false);
        });
    },
  });

  const { errors, values, touched, setErrors, isSubmitting, handleSubmit, getFieldProps, setFieldValue } = formik;

  const getOpObj = option => {
    if (!option._id) option = types.find(op => op._id === option);
    return option;
  };

  const handleUploadImage = event => {
    setIsUploadingImage(true);
    const f = event.target.files[0];
    const fData = new FormData();
    fData.append('file', f, f.name);
    axios
      .post(`${process.env.REACT_APP_SERVICE_BASE_URL}/upload`, fData, {
        headers: {
          token: token.token,
        },
      })
      .then(res => {
        const { fileId, fullUrl } = res.data.data;
        setFieldValue('url', fullUrl);
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => setIsUploadingImage(false));
  };

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <Grid container spacing={4}>
            <Grid item md={4}>
              <img src={values.url} alt={values.url} style={{ maxWidth: '100%' }} />
            </Grid>
            <Grid item md={8}>
              <label htmlFor="upload-img-btn">
                <input
                  onChange={handleUploadImage}
                  accept="image/*"
                  style={{ display: 'none' }}
                  type="file"
                  id="upload-img-btn"
                />
                <Button variant="outlined" component="span">
                  Thêm ảnh minh họa
                </Button>
              </label>
              {isUploadingImage ? <CircularProgress /> : null}
            </Grid>
          </Grid>
          <TextField
            required
            fullWidth
            type="text"
            label="Giá"
            {...getFieldProps('cost')}
            error={Boolean(touched.cost && errors.cost)}
            helperText={touched.cost && errors.cost}
          />
          <Grid item md={12}>
            <Stack spacing={3}>
              <Autocomplete
                required
                id="combo-box-type"
                options={types}
                getOptionLabel={option => (getOpObj(option) ? getOpObj(option).name : '')}
                onChange={(e, v) => {
                  setFieldValue('type', getOpObj(v)._id);
                }}
                value={values.type}
                renderInput={params => (
                  <TextField {...params} required label="Loại" error={Boolean(touched.type && errors.type)} />
                )}
              />
            </Stack>
          </Grid>
        </Stack>

        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }} />
        {errors.error != null && (
          <Alert severity="error">
            {typeof errors.error === 'string' ? (
              <p>{errors.error}</p>
            ) : (
              errors.error.map((v, i) => <p key={i.toString()}>{v}</p>)
            )}
          </Alert>
        )}
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }} />

        <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
          Lưu
        </LoadingButton>
      </Form>
    </FormikProvider>
  );
}
